import { useQuery } from "@tanstack/react-query";

import { isPlus } from "@/api/subscription";
import { useAuthStore } from "@/store/authStore";

/** 현재 사용자의 Plus 구독 여부 조회 */
export function useIsPlusQuery() {
  const userId = useAuthStore(state => state.user?.id);

  return useQuery({
    queryKey: ["isPlus", userId],
    queryFn: () => isPlus(userId!),
    enabled: Boolean(userId),
    staleTime: 1000 * 60 * 5, // 5분 — 구매 성공 시 낙관적 캐시가 즉시 재조회로 덮이지 않도록
    refetchOnWindowFocus: true, // 탭/앱 복귀 시 구독 만료 반영
  });
}
